<template>
  <div>
    <div class="container main-search" :class="{ 'no-scroll': show }" id="head">
      <h1 class="intro-text">Koszt naprawy</h1>
      <p class="brand-color site-description">
        Wyszukaj naprawę i sprawdź jej koszt
      </p>

      <div class="row mb-2">
        <div class="col">
          <input
            v-oninput="searchPhrase"
            @focus="moveInputToTop"
            class="form-control"
            name="search"
            type="search"
            placeholder="Wyszukaj po nazwie..."
          />
        </div>
      </div>

      <div class="row" v-if="isLoading">
        <div class="d-flex justify-content-center">
          <Loading />
        </div>
      </div>
      <div class="row" v-else-if="repairs.length > 0">
        <p></p>
        <strong
          >wyniki dla: <u>{{ searchPhrase }}</u></strong
        >
        <ul class="list-group list-group-flush">
          <li
            class="list-group-item"
            v-for="repair in repairs"
            :key="repair.id"
          >
            <router-link
              class="repair-link"
              :to="{ name: 'repair-detail', params: { repairId: repair.id } }"
            >
              {{ repair.name }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="row" v-else-if="searchPhrase && searchPhrase.length < 3">
        <p></p>
        <p>Musisz wpisać co najmniej 3 litery by wyszukać.</p>
      </div>
      <div class="row" v-else-if="notFound">
        <p></p>
        <p class="link-danger">Nie znaleziono.</p>
      </div>

      <p class="gray-text">albo wybierz z listy</p>
      <ul class="p-0">
        <li
          v-for="category in categories"
          :key="category.id"
          class="category container-fluid"
        >
          <div
            class="row align-items-center"
            @click="expandCategory(category.id)"
          >
            <div class="col-2" v-if="category.icon">
              <img
                :src="category.icon"
                class="category-icon mx-auto d-block center-block"
                v-if="category.icon"
              />
            </div>
            <div class="col-10 category-name">
              {{ category.name }}
            </div>
          </div>
          <div
            class="repairs-in-category mt-4"
            v-if="expandedCategories.includes(category.id)"
          >
            <div v-if="loadingRepairs.includes(category.id)"><Loading /></div>
            <div class="row" v-else>
              <div class="col-12">
                <router-link
                  class="repair-link"
                  v-for="repair in category.repairs"
                  :key="repair.id"
                  :to="{
                    name: 'repair-detail',
                    params: { repairId: repair.id },
                  }"
                >
                  <p>{{ repair.name }}</p>
                </router-link>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <mail-to-us
            bold-text="Brakuje twojej naprawy na liście?"
            small-text="Prześlij nam informację lub kosztorys do weryfikacji"
            :type="FormTypes.REPAIRS"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "@/components/Loading";
import debounce from "debounce";
import axios from "axios";
import MailToUs from "@/improvementForms/MailToUs";
import { FormTypes } from "@/improvementForms/formTypes";

const oninput = {
  created(el, binding) {
    el.oninput = () => {
      binding.instance.searchPhrase = el.value;
    };
  },
};

export default {
  created() {
    this.searchRepairs = debounce(this.searchRepairs, 300);
  },
  mounted() {
    axios.get("/api/faults/categories/").then((response) => {
      this.categories = response.data;
    });
    document.title = "Znajdź naprawę";
  },
  data: function () {
    return {
      searchPhrase: "",
      isLoading: false,
      repairs: [],
      notFound: false,
      categories: [],
      expandedCategories: [],
      loadingRepairs: [],
      FormTypes,
    };
  },
  methods: {
    searchRepairs() {
      let searchUrl = `/api/faults/repairs/search?q=${this.searchPhrase}`;

      if (this.searchPhrase.length >= 3) {
        this.isLoading = true;
        axios.get(searchUrl).then((response) => {
          this.repairs = response.data;
          this.isLoading = false;
          if (this.repairs.length === 0) {
            this.notFound = true;
          }
        });
      } else {
        this.repairs = [];
        this.notFound = false;
      }
    },
    moveInputToTop() {
      window.scrollTo(0, this.$refs["search-form"].offsetTop);
    },
    expandCategory(categoryId) {
      if (this.expandedCategories.includes(categoryId)) {
        this.expandedCategories.splice(
          this.expandedCategories.findIndex((i) => i === categoryId),
          1
        );
      } else {
        this.expandedCategories.push(categoryId);
        if (!this.categories.find((c) => c.id === categoryId)?.repairs) {
          this.loadingRepairs.push(categoryId);
          axios
            .get(`/api/faults/repairs/?categoryId=${categoryId}`)
            .then((response) => {
              this.categories.find((c) => c.id === categoryId).repairs =
                response.data;
              this.loadingRepairs.splice(
                this.loadingRepairs.findIndex((i) => i === categoryId),
                1
              );
            });
        }
      }
      console.log(this.expandedCategories);
    },
  },
  watch: {
    searchPhrase() {
      this.searchRepairs();
    },
  },
  directives: {
    oninput,
  },
  components: {
    Loading,
    MailToUs,
  },
};
</script>
<style scoped>
.brand-color {
  color: #0072db;
}

.site-description {
  font-size: 16px;
}

.gray-text {
  margin-top: 32px;
  color: gray;
  font-size: 15px;
}

.category {
  padding-left: 0;
  margin-top: 2rem;
  list-style: none;
  cursor: pointer;
}

.category-name {
  font-size: 21px;
  font-weight: bold;
  line-height: normal;
}

.category-icon {
  width: auto;
}

.repair-link {
  color: black;
  text-decoration: none;
}
</style>
